<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Tooltip
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="placement" class="content__row-label">Placement</label>
      <select [(ngModel)]="selectedPlacement" class="c-input-group__control" id="placement">
        <ng-container *ngFor="let placement of placements">
          <option [value]="placement">{{ placement }}</option>
        </ng-container>
      </select>
      <label for="language" class="content__row-label">Language</label>
      <select [(ngModel)]="selectedLanguage" class="c-input-group__control" (change)="onLanguageChange()" id="language">
        <ng-container *ngFor="let language of languages">
          <option [value]="language">{{ language }}</option>
        </ng-container>
      </select>
    </div>
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="inlineCheckbox1" class="c-input-check-inline__input" type="checkbox" name="hasCloseButton"
          [(ngModel)]="hasCloseButton">
        <label for="inlineCheckbox1" class="c-input-check-inline__label">Has CloseButton</label>
      </div>
      <div class="c-input-check-inline">
        <input id="inlineCheckbox3" class="c-input-check-inline__input" type="checkbox" name="hasCaret"
          [(ngModel)]="hasCaret">
        <label for="inlineCheckbox3" class="c-input-check-inline__label">Has Caret</label>
      </div>
    </div>
    <button #tooltipTargetReference aria-describedby="tooltip1">Show Tooltip</button>
    <maced-tooltip id="tooltip1" [placement]="selectedPlacement" [hasCloseButton]="hasCloseButton" [hasCaret]="hasCaret"
      [tooltipTargetReference]="tooltipTargetReference" [message]="message">
    </maced-tooltip>
  </div>
</div>